<script setup lang="ts">
  import { computed, nextTick, onBeforeUnmount, onMounted, ref } from "vue";
  import { useRoute } from "vue-router";
  import bvipTabImage from "~/assets/images/legal-data/bvip-tab.png";
  import enterpriseBanner1 from "~/assets/images/legal-data/enterpriseBanner1.png";
  import enterpriseBanner2 from "~/assets/images/legal-data/enterpriseBanner2.png";
  import leftArrowIcon from "~/assets/images/legal-data/left-arrow.svg";
  import professionalBanner1 from "~/assets/images/legal-data/professionalBanner1.png";
  import professionalBanner2 from "~/assets/images/legal-data/professionalBanner2.png";
  import rightArrowIcon from "~/assets/images/legal-data/right-arrow.svg";
  import svipTabImage from "~/assets/images/legal-data/svip-tab.png";
  import vipTabImage from "~/assets/images/legal-data/vip-tab.png";
  import CoreFunction from "~/components/aigc/CoreFunction.vue";
  import Anchor from "~/components/core/Anchor/Anchor.vue";
  import { useAnchor } from "~/composables/useAnchor";
  import { useAnchorShow } from "~/composables/useAnchorShow";
  import { SYSTEM_VERSION } from "~/enum/cache/cookie";
  import {
    AiFaLvZiXun,
    AiYueDuCaiPanWenShu,
    FaLvJianSuo,
    FaLvZiXunTuiJian,
    HeGuiAi,
    HeTongShenCha,
    HeTongShengCheng,
    LvShiHan,
    WenLvShi,
    WenShuAi,
    XiaoLiZhiNengTi,
  } from "~/enum/cdn";
  import { DATA_DOWNLOAD_URL, DATA_URL } from "~/env";
  import { useMainStore } from "~/stores";
  import Common from "~/utils/common";
  import Cookie from "~/utils/cookie";

  definePageMeta({
    layout: "nav-layout",
    middleware: ["search"],
  });

  // import professionalTable from "~/assets/images/legal-data/professiona-table.png";
  // import enterpriseTable from "~/assets/images/legal-data/enterprise-table.png";

  const { $req: req } = useNuxtApp();
  const { anchorShow } = useAnchorShow();
  const store = useMainStore() as any;
  const api = useApi();
  const route = useRoute();

  // 跳转律助
  // const toDls = (name: keyof typeof URL_LIST, hash?: string) => {
  //   if (name === "buyLogin") {
  //     location.replace(`${LOGIN_URL}&redirect=${encodeURIComponent(location.href + hash)}`);
  //     return;
  //   }
  //   location.href = URL_LIST[name];
  // };
  // 跳转法搜
  const toData = () => {
    const isEnterprise = route.path === "/search/enterprise";
    if (store.login) {
      api.switchVersion({ versionType: isEnterprise ? 2 : 1 }).then(() => {
        Cookie.set(SYSTEM_VERSION, isEnterprise ? "enterprise" : "professional");
        Common.openWin(DATA_URL);
      });
    } else {
      Cookie.set(SYSTEM_VERSION, isEnterprise ? "enterprise" : "professional");
      Common.openWin(isEnterprise ? `${DATA_URL}/enterprise` : DATA_URL);
    }
  };
  // 跳转 app 下载
  const toDownload = () => {
    Common.openWin(DATA_DOWNLOAD_URL);
  };

  // 特殊埋点
  const postSpecialTrack = () => {
    api.ai.specialTrack({ referer: window.location.href });
  };

  interface FunctionItem {
    functionName: string;
    functionDesc: string;
  }
  interface CoreFunctionProps {
    title: string;
    description?: string;
    url: string;
    imagePlacement: "left" | "right";
    mediaType?: "image" | "video";
    bg: "white" | "blue";
    anchorID: string;
    btnEmit: (...args: any[]) => void;
    functionList: FunctionItem[];
  }
  const professionalCoreList: CoreFunctionProps[] = [
    {
      title: "专业法律检索",
      description: "5亿+全域法律数据，语义、关键词、长文本多重检索模式加持",
      url: FaLvJianSuo,
      anchorID: "anchor1",
      bg: "blue",
      imagePlacement: "left",
      btnEmit: toData,
      functionList: [
        {
          functionName: "全域法律大数据：",
          functionDesc: "5亿+法律数据，知识产权和地产工程两大专业数据库，兼具深度、广度、速度。",
        },
        {
          functionName: "智能语义检索：",
          functionDesc:
            "语义检索、关键词检索、长文本检索等多重检索模式加持，支持争议焦点、案情描述和法律文书直接搜索。",
        },
        {
          functionName: "一次检索，多维呈现：",
          functionDesc: "一次检索， 案例、法规、观点、法讯同步输出，便于法律从业者全方位了解信息。",
        },
      ],
    },
    {
      title: "AI阅读裁判文书",
      description: "类案检索总结+智能摘要+裁判要点+时间轴，节省约80%阅读裁判文书时间",
      url: AiYueDuCaiPanWenShu,
      anchorID: "anchor2",
      bg: "white",
      imagePlacement: "right",
      btnEmit: toData,
      functionList: [
        {
          functionName: "智能摘要：",
          functionDesc:
            "基于案情快速生成摘要， 诉讼请求、争议焦点、裁判依据、裁判结果等核心案件信息一目了然，快速掌握案件要点。",
        },
        {
          functionName: "裁判要点：",
          functionDesc: "基于裁判文书快速生成裁判要点，帮助用户更快了解法院的判决思路和法律适用原则。",
        },
        {
          functionName: "案例时间轴：",
          functionDesc: "通过数据可视化，AI会根据发生的时间和事件梳理案情，帮助用户快速了解案件经过。",
        },
        {
          functionName: "智能报告：",
          functionDesc: "智能抽取裁判文书的内容要素 ，一键生成结合AI检索总结的类案检索报告。",
        },
      ],
    },
    {
      title: "小理AI",
      description: "专业法律AI，业内领先的法律AI大模型",
      mediaType: "video",
      url: " https://media.delilegal.com/video/www/487eb247.mp4",
      anchorID: "anchor3",
      bg: "blue",
      imagePlacement: "left",
      btnEmit: toData,
      size: "small",
      functionList: [
        {
          functionName: "法律研究：",
          functionDesc:
            "智能拆解法律问题，联动全库检索并自动生成结构化报告，重构从问题定位到成果输出的全流程研究闭环。",
        },
        {
          functionName: "AI检索：",
          functionDesc: "读取5亿+全域法律数据，像聊天一样进行法律检索，实现法规与类案高效精准定位，同步输出检索报告。",
        },
        {
          functionName: "合同生成：",
          functionDesc:
            "通过“输入-确定大纲-生成-修改”的可控步骤，将模糊的生成动作透明化，确保生成的合同兼具法律专业性与业务场景灵活适配性。",
        },
        {
          functionName: "合同审查：",
          functionDesc:
            "合同总体审查与条款逐条审查结合，自定义审查规则与系统配置审查规则结合，并支持智能选择审查主体立场，精准识别合同风险，可一键完成修订。",
        },
        {
          functionName: "法律文书：",
          functionDesc: "高效生成各类诉讼文书与非诉文书，并支持67类的要素文书与传统文书的自由生成转换。",
        },
        {
          functionName: "文本分析：",
          functionDesc:
            "一键上传多份文档，精准定位场景化需求、提炼文档关键信息并进行深度解析（如案件分析、证据分析、合同分析），快速掌握复杂材料核心要旨。",
        },
        {
          functionName: "专业模型：",
          functionDesc:
            "融合特定法律领域的海量知识、实务规则和工作流，提供高度精准、场景闭环的“一站式”特定业务领域的智能解决方案。",
        },
      ],
    },
    {
      title: "AI+律师法律咨询",
      description: "7*24小时AI+律师智能法律咨询，随时随地解答各类法律问题",
      url: WenLvShi,
      anchorID: "anchor4",
      bg: "white",
      imagePlacement: "right",
      btnEmit: toData,
      functionList: [
        {
          functionName: "AI法律咨询：",
          functionDesc:
            "覆盖各种法律案由，无论是婚姻问题、房产纠纷还是交通事故，AI都可通过问题理解，正确引用法规和案例，帮助用户解答具体的法律问题。",
        },
        {
          functionName: "律师智能匹配：",
          functionDesc: "根据用户的实际法律需求，智能匹配相应领域及要求的专业律师，提供个性化的法律解决方案。",
        },
      ],
    },
    {
      title: "智能数字名片",
      description: "智能识别纸质名片、个人简介智能完善、AI专属形象塑造、链接法律需求打通案源",
      url: XiaoLiZhiNengTi,
      anchorID: "anchor5",
      bg: "blue",
      imagePlacement: "left",
      btnEmit: toData,
      functionList: [
        {
          functionName: "专属形象，AI打造：",
          functionDesc:
            "上传纸质名片即可智能识别，省去重复填写，AI可智能生成律师/律所介绍，展现职业优势，还可根据需求AI优化形象照效果，展现个人魅力。",
        },
        {
          functionName: "链接案源，精准转化：",
          functionDesc:
            "AI算法会将您的名片与潜在客户的法律需求精准匹配并做推荐，名片一键社交分享，实现从展示到案源线索的精准转化。",
        },
        {
          functionName: "名片智能体：",
          functionDesc:
            "链接得理法律大模型，也可接入自建知识库，为客户提供7x24小时法律问题的初步解答，筛选意向客户，减轻律师咨询压力。",
        },
      ],
    },
    {
      title: "法律资讯推荐",
      description: "整合新法速递、法律观点、全国商机、法律新闻等不同媒体平台的法律资讯，实时更新，提供个性化订阅服务",
      url: FaLvZiXunTuiJian,
      anchorID: "anchor6",
      bg: "white",
      imagePlacement: "right",
      btnEmit: toData,
      functionList: [
        {
          functionName: "新法速递：",
          functionDesc: "收录人大、国务院、法院等权威机构最新颁布的法律法规和政府文件，了解最新立法动态。",
        },
        {
          functionName: "法律观点：",
          functionDesc: "集成知名律所和机构发表的最新观点，打造法律人专属的知识分享社区。",
        },
        {
          functionName: "全国商机：",
          functionDesc: "实时收录全国各地采购和招投标商机内容 ，助力律师洞察趋势、把握商机。",
        },
        {
          functionName: "法讯订阅：",
          functionDesc: "整合不同媒体平台、不同领域的最新法律资讯，提供个性化订阅服务。",
        },
      ],
    },
  ];
  const enterpriseCoreList: CoreFunctionProps[] = [
    {
      title: "AI法律咨询",
      description: "7*24小时智能法律咨询，助您轻松应对各种企业法律问题",
      url: AiFaLvZiXun,
      anchorID: "anchor1",
      bg: "blue",
      imagePlacement: "left",
      btnEmit: toData,
      functionList: [
        {
          functionName: "",
          functionDesc: "支持7×24小时问答服务，不限次数。",
        },
        {
          functionName: "",
          functionDesc: "覆盖政策解读、劳动用工、合同纠纷、公司治理等法律领域。",
        },
        {
          functionName: "",
          functionDesc: "回答内容基于5亿+法律数据与司法实践，精准权威。",
        },
        {
          functionName: "",
          functionDesc: "提供答案+法律依据双输出，便于内部沟通和决策。",
        },
      ],
    },
    {
      title: "合同审查",
      description: "一分钟读懂整份合同，三分钟标出风险重点！",
      url: HeTongShenCha,
      anchorID: "anchor2",
      bg: "white",
      imagePlacement: "right",
      btnEmit: toData,
      functionList: [
        {
          functionName: "快速解析合同：",
          functionDesc: "AI秒读整份合同，基于海量法律知识库和行业标准，快速完成条款梳理与结构解析，不再人工逐页翻阅。",
        },
        {
          functionName: "自动审查风险：",
          functionDesc:
            "一键高亮关键条款与风险点，精准识别付款、违约、期限、管辖权等重点内容，自动标记潜在陷阱与合规漏洞，查得准、改得快。",
        },
      ],
    },
    {
      title: "合同生成",
      description: "一句话起草，秒出专业合同！",
      url: HeTongShengCheng,
      anchorID: "anchor3",
      bg: "blue",
      imagePlacement: "left",
      btnEmit: toData,
      functionList: [
        {
          functionName: "智能高效生成：",
          functionDesc:
            "依托海量真实合同样本与行业标准模板，高效生成结构严谨、内容精准、格式规范的合同文本，大幅提升合同起草效率与准确性。",
        },
        {
          functionName: "条款灵活定制：",
          functionDesc:
            "支持多种合同类型与业务场景，自动生成关键条款（如付款、期限、违约、保密等），可根据企业实际需求灵活调整，确保合同文本合规合法。",
        },
      ],
    },
    {
      title: "合规AI",
      description: "企业的专属“合规顾问”，随时在线！",
      url: HeGuiAi,
      anchorID: "anchor4",
      bg: "white",
      imagePlacement: "right",
      btnEmit: toData,
      functionList: [
        {
          functionName: "合规咨询：",
          functionDesc:
            "为企业提供专业、及时的合规咨询服务。日常法规解读、政策咨询，以及合规风险评估都能快速响应，帮助企业全面理解并遵守相关法规，降低合规风险，保障企业稳定发展。",
        },
        {
          functionName: "法规洞察：",
          functionDesc:
            "为用户提供详尽的法规解读和政策动态。通过一键咨询，企业可轻松掌握复杂法规要点，确保合规措施的科学合理性，提高效率，助力企业合法合规运营。",
        },
      ],
    },
    {
      title: "文书AI",
      url: WenShuAi,
      anchorID: "anchor5",
      bg: "blue",
      imagePlacement: "left",
      btnEmit: toData,
      functionList: [
        {
          functionName: "文书生成：",
          functionDesc:
            "基于专业法律大模型，智能生成公司章程、股权激励计划、诉讼文书等标准化法律文书。用户输入关键要素，系统自动匹配法律条款并生成结构化文本。",
        },
        {
          functionName: "文档分析：",
          functionDesc:
            "对文档进行深度解析，提取关键信息，识别潜在风险点。并可解析用户上传的文档再次进行文书生成，例如根据用户上传的起诉状生成对应的答辩状。",
        },
      ],
    },
    {
      title: "律师函",
      url: LvShiHan,
      anchorID: "anchor6",
      bg: "white",
      imagePlacement: "right",
      btnEmit: toData,
      functionList: [
        {
          functionName: "服务内容：",
          functionDesc: "资金拖欠、权益侵害、合同违约等全方位咨询；为企业提供合规、高效的律师函服务。",
        },
        {
          functionName: "执业律师背书：",
          functionDesc: "由入驻平台的执业律师起草并加盖律所签章，确保函件符合法律及司法实践要求。",
        },
        {
          functionName: "全流程跟踪：",
          functionDesc: "平台下单→律师接单→沟通案情→文书制作→函件跟踪确认→服务评价。",
        },
      ],
    },
  ];
  const coreList = computed(() => {
    return route.path === "/search/enterprise" ? enterpriseCoreList : professionalCoreList;
  });
  const professionalAnchorList = [
    {
      id: "anchor1",
      title: "专业法律检索",
      icon: "gaojijiansuo12",
      activeIcon: "gaojijiansuo1",
    },
    {
      id: "anchor2",
      title: "AI阅读裁判文书",
      icon: "wenshu12",
      activeIcon: "wenshu13",
    },
    {
      id: "anchor3",
      title: "小理AI",
      icon: "zixun111",
      activeIcon: "zixun113",
    },
    {
      id: "anchor4",
      title: "AI+律师法律咨询",
      icon: "lvshijianjie1",
      activeIcon: "lvshijianjie11",
    },
    {
      id: "anchor5",
      title: "智能数字名片",
      icon: "xueshuyanjiu11",
      activeIcon: "xueshuyanjiu13",
    },
    {
      id: "anchor6",
      title: "法律资讯推荐",
      icon: "xinwenzixun1",
      activeIcon: "xinwenzixun11",
    },
    {
      id: "anchor7",
      title: "产品优势",
      icon: "xunzhang1",
      activeIcon: "xunzhang12",
    },
  ];
  const enterpriseAnchorList = [
    {
      id: "anchor1",
      title: "AI法律咨询",
      icon: "gaojijiansuo12",
      activeIcon: "gaojijiansuo1",
    },
    {
      id: "anchor2",
      title: "合同审查",
      icon: "wenshu12",
      activeIcon: "wenshu13",
    },
    {
      id: "anchor3",
      title: "合同生成",
      icon: "24gf-fileText1",
      activeIcon: "24gf-fileText17",
    },
    {
      id: "anchor4",
      title: "合规AI",
      icon: "xueshuyanjiu11",
      activeIcon: "xueshuyanjiu13",
    },
    {
      id: "anchor5",
      title: "文书AI",
      icon: "zixun111",
      activeIcon: "zixun113",
    },
    {
      id: "anchor6",
      title: "律师函",
      icon: "xinwenzixun1",
      activeIcon: "xinwenzixun11",
    },
    {
      id: "anchor7",
      title: "产品优势",
      icon: "xunzhang1",
      activeIcon: "xunzhang12",
    },
  ];
  const anchorList = computed(() => {
    return route.path === "/search/enterprise" ? enterpriseAnchorList : professionalAnchorList;
  });
  const { curAnchorID } = useAnchor(anchorList.value);
  const icons = [
    {
      icon: "Group2648",
      name: "案例",
    },
    {
      icon: "Group2649",
      name: "法规",
    },
    {
      icon: "Group2656",
      name: "观点",
    },
    {
      icon: "Group2650",
      name: "法讯",
    },
    {
      icon: "hangzhengchufa1",
      name: "行政处罚",
    },
    {
      icon: "Group26491",
      name: "检察文书",
    },
    {
      icon: "tianpingcfs11",
      name: "法官",
    },
    {
      icon: "Group26561",
      name: "律师",
    },
    {
      icon: "lvsuoguanli1",
      name: "律所",
    },
  ];
  const advantageList = [
    {
      name: "全域法律数据",
      iconList: [
        {
          icon: "shuju1",
          name: "5亿+法律数据",
        },
        {
          icon: "zhishichanquan1",
          name: "知识产权专业库",
        },
        {
          icon: "zhuanyeku1",
          name: "地产工程专业库",
        },
        {
          icon: "shishishuju1",
          name: "数据实时更新",
        },
        {
          icon: "changguijiansuo1",
          name: "多重检索方式",
        },
        {
          icon: "shujujieguo1",
          name: "结果多维呈现",
        },
      ],
    },
    {
      name: "全域法律应用",
      iconList: [
        {
          icon: "hetong-31",
          name: "智能合同服务",
        },
        {
          icon: "erjitubiao-jiansuozhongxin-jiansuodingyue-1",
          name: "法律研究辅助",
        },
        {
          icon: "fenxi6",
          name: "案情分析预测",
        },
        {
          icon: "lvshi",
          name: "日常法律咨询",
        },
        {
          icon: "falv-31",
          name: "律师智能推荐",
        },
        {
          icon: "zhishi-21",
          name: "智能法律文书",
        },
      ],
    },
    {
      name: "专有模型部署",
      iconList: [
        {
          icon: "damoxingjiaosemoban",
          name: "通用大模型",
        },
        {
          icon: "falv-4",
          name: "法律大模型",
        },
        {
          icon: "beian",
          name: "国家算法备案",
        },
      ],
    },
  ];

  const enterpriseAdvantageList = [
    {
      title: "全域法律数据",
      text: "实时更新的法律数据库，始终保持专业领先平台集成5亿+法律法规、案例与政策资讯，动态更新、权威可查，为企业提供始终可靠的法律支持。",
      icon: "shuju1-hg0am2e9",
    },
    {
      title: "AI高效赋能",
      text: "AI赋能，效率大幅提升AI赋能，效率大幅提升，轻松应对法律事务 依托大语言模型与语义检索引擎，平台实现快速响应、精准定位、智能处理，合同审查、法律咨询等操作，可大量节省时间。",
      icon: "damoxingjiaosemoban-hg0am2e9",
    },
    {
      title: "一站式法律服务",
      text: "高性价比的企业法律解决方案 集成法律咨询、合同生成、审查、文书起草、律师服务于一体，企业无需多平台切换，一站满足企业法律需求。",
      icon: "falv-4-hg0am2d4",
    },
    {
      title: "AI与律师协同服务",
      text: "“AI+律师”协同闭环，线上线下全场景结合 融合AI智能处理与专业律师服务，既能智能解答常见问题，又能落地处理复杂案件、起草函件、应诉维权，实现真正的法律服务闭环。",
      icon: "lvshi-hg0am2d8",
    },
  ];

  // const tableImage = computed(() => {
  //   return route.value.path === "/search/enterprise" ? enterpriseTable : professionalTable;
  // });

  type VipTabType = "SVIP" | "VIP" | "COMPANY";
  const isEnterpriseRoute = computed(() => route.path === "/search/enterprise");

  // 购买
  const onBuy = () => {
    const redirectUrl = encodeURIComponent(window.location.href);
    const typeParam = `&type=${activeTab.value}`;
    const planIdParam = currentPlanId.value ? `&planId=${currentPlanId.value}` : "";
    const targetUrl = `${DATA_URL}/data-vip?redirect=${redirectUrl}${typeParam}${planIdParam}`;
    window.open(targetUrl, "_blank");
  };

  // 当前选中的tab
  const activeTab = ref<VipTabType>(isEnterpriseRoute.value ? "COMPANY" : "SVIP");
  const currentTabBg = computed(() => {
    if (isEnterpriseRoute.value) return bvipTabImage;
    return activeTab.value === "VIP" ? vipTabImage : svipTabImage;
  });
  // 设置当前选中的 tab
  const setActiveTab = (tab: VipTabType): void => {
    if (isEnterpriseRoute.value || activeTab.value === tab) return;
    activeTab.value = tab;
    planWindowStart.value = 0;
    loadPlan();
  };

  // 当前选中的 planId
  const currentPlanId = ref<string>("");
  // 设置当前选中的 planId
  const setCurrentPlanId = (planId: string): void => {
    currentPlanId.value = planId;
    syncPlanWindowByPlanId(planId);
  };

  // 计划列表
  const planList = ref<any[]>([]);

  // 滑动窗口状态
  const PLAN_VISIBLE_COUNT = 4;
  const plansSliderRef = ref<HTMLElement | null>(null);
  const planWindowStart = ref(0);
  const planCardWidthPx = ref(0);
  const planStepPx = ref(0);

  const isCompanyTab = computed(() => activeTab.value === "COMPANY");
  const maxPlanWindowStart = computed(() => Math.max(0, planList.value.length - PLAN_VISIBLE_COUNT));
  const showPlanSwitchArrows = computed(() => !isCompanyTab.value && planList.value.length > PLAN_VISIBLE_COUNT);
  const canSlidePrev = computed(() => showPlanSwitchArrows.value && planWindowStart.value > 0);
  const canSlideNext = computed(() => showPlanSwitchArrows.value && planWindowStart.value < maxPlanWindowStart.value);

  const sliderCssVars = computed(() => ({
    "--plan-card-width": `${Math.max(planCardWidthPx.value, 0)}px`,
  }));
  const planTrackStyle = computed(() => ({
    transform: `translate3d(${-planWindowStart.value * planStepPx.value}px, 0, 0)`,
    transitionTimingFunction: "ease",
    transitionDuration: "300ms",
  }));

  const updatePlanSliderMetrics = () => {
    const sliderWidth = plansSliderRef.value?.clientWidth ?? 0;
    if (sliderWidth <= 0) {
      planCardWidthPx.value = 0;
      planStepPx.value = 0;
      return;
    }
    const cardWidth = (sliderWidth - 12 * (PLAN_VISIBLE_COUNT - 1)) / PLAN_VISIBLE_COUNT;
    planCardWidthPx.value = cardWidth;
    planStepPx.value = cardWidth + 12;
  };

  const syncPlanWindowByPlanId = (id: string) => {
    if (isCompanyTab.value) return;
    const selectedIndex = planList.value.findIndex((item) => item.planId === id);
    if (selectedIndex < 0) {
      planWindowStart.value = 0;
      return;
    }
    if (selectedIndex < planWindowStart.value) {
      planWindowStart.value = selectedIndex;
      return;
    }
    if (selectedIndex >= planWindowStart.value + PLAN_VISIBLE_COUNT) {
      planWindowStart.value = selectedIndex - PLAN_VISIBLE_COUNT + 1;
    }
  };

  const slidePlanPrev = () => {
    if (!canSlidePrev.value) return;
    planWindowStart.value -= 1;
  };

  const slidePlanNext = () => {
    if (!canSlideNext.value) return;
    planWindowStart.value += 1;
  };

  // 加载计划
  const loadPlan = () => {
    const param = { type: activeTab.value };
    api.getPlanList(param).then((res: any) => {
      if (res && res.length > 0) {
        planList.value = res;
        planWindowStart.value = 0;
        currentPlanId.value = res[0].planId;
        syncPlanWindowByPlanId(res[0].planId);
        nextTick(() => {
          updatePlanSliderMetrics();
        });
      }
    });
  };

  const vipImageUrl = ref("");
  const vipImageMap = ref<Record<string, string>>({});
  const currentVipImageUrl = computed(() => {
    return vipImageMap.value[activeTab.value] || vipImageUrl.value;
  });
  const getVipImageUrl = () => {
    req.getVipImageUrl({ code: "PORTAL_PAY_IMG" }).then((res: any) => {
      if (!Array.isArray(res) || res.length === 0) return;
      const keyedItems = res.filter((item: any) => item?.key && item?.value);
      if (keyedItems.length > 0) {
        const imageMap: Record<string, string> = {};
        keyedItems.forEach((item: any) => {
          imageMap[item.key] = item.value;
        });
        vipImageMap.value = imageMap;
      }
      if (res[0]?.value) vipImageUrl.value = res[0].value;
    });
  };

  // 专业版数据
  const professionalData = ref({
    title: "- 得理法搜 -",
    subTitle1: "专业法律AI",
    subTitle2: "法律难题，就找得理法搜",
    banner1: professionalBanner1,
    banner2: professionalBanner2,
  });
  // 企业版数据
  const enterpriseData = ref({
    title: "- 得理法搜企业版 -",
    subTitle1: "“AI+律师”集成服务",
    subTitle2: "护航企业健康发展",
    banner1: enterpriseBanner1,
    banner2: enterpriseBanner2,
  });

  const data = computed(() => {
    return route.path === "/search/enterprise" ? enterpriseData.value : professionalData.value;
  });

  onMounted(() => {
    window.addEventListener("resize", updatePlanSliderMetrics);
    getVipImageUrl();
    loadPlan();
    postSpecialTrack();
  });

  onBeforeUnmount(() => {
    window.removeEventListener("resize", updatePlanSliderMetrics);
  });
</script>

<template>
  <div class="legal-data">
    <Anchor v-show="anchorShow" :id="curAnchorID" :anchor="anchorList" />
    <div class="legal-data-banner" :style="{ backgroundImage: `url(${data.banner1})` }">
      <div class="legal-data-banner-content">
        <p>{{ data.title }}</p>
        <p>{{ data.subTitle1 }}</p>
        <p>{{ data.subTitle2 }}</p>
        <div class="legal-data-btns">
          <a-button @click="toData">免费体验</a-button>
          <a-button class="app-download-btn app-download-mobile" @click="toDownload">APP下载</a-button>
          <a-tooltip placement="top" overlay-class-name="qrcode-tooltip" :arrow="false">
            <template #title>
              <img class="qrcode-tooltip-img" src="~/assets/images/qrcode/legal-search.png" />
            </template>
            <a-button class="app-download-btn app-download-pc">APP下载</a-button>
          </a-tooltip>
          <a-tooltip placement="top" overlay-class-name="qrcode-tooltip" :arrow="false">
            <template #title>
              <img
                v-if="!isEnterpriseRoute"
                class="qrcode-tooltip-img"
                src="~/assets/images/qrcode/data-applet-qrcode.jpg" />
              <img v-else class="qrcode-tooltip-img" src="~/assets/images/qrcode/data-applet-enterprise-qrcode.png" />
            </template>
            <a-button class="app-download-btn">小程序</a-button>
          </a-tooltip>
        </div>
      </div>
    </div>
    <div id="anchor-start" class="legal-data-icons">
      <div v-for="(item, idx) of icons" :key="idx" class="legal-data-icon">
        <icon-font :type="item.icon" />
        <span>{{ item.name }}</span>
      </div>
    </div>
    <div class="legal-data-show" :style="{ backgroundImage: `url(${data.banner1})` }">
      <img class="legal-data-show-image" :src="data.banner2" />
    </div>
    <CoreFunction v-for="(item, idx) of coreList" v-bind="item" :key="`coreList${idx}`" />
    <div class="legal-data-advantage">
      <h2 id="anchor7" class="legal-data-advantage-title">产品优势</h2>
      <div v-if="route.path === '/search/enterprise'" class="legal-data-enterprise-box">
        <div v-for="(item, idx) of enterpriseAdvantageList" :key="idx" class="legal-data-enterprise-card">
          <icon-font :type="item.icon" />
          <div class="legal-data-enterprise-card-title">{{ item.title }}</div>
          <div class="legal-data-enterprise-card-text">{{ item.text }}</div>
        </div>
      </div>
      <div v-else class="legal-data-advantage-box">
        <div
          v-for="(item, idx) of advantageList"
          :key="`advantageList${idx}`"
          class="legal-data-advantage-card"
          :class="`legal-data-advantage-card${idx + 1}`">
          <h3>{{ item.name }}</h3>
          <div v-for="icon of item.iconList" :key="icon.icon" class="legal-data-advantage-card-icon">
            <icon-font :type="icon.icon" />
            <span>{{ icon.name }}</span>
          </div>
        </div>
      </div>
    </div>
    <div id="anchor-end" class="legal-data-vip">
      <h2 class="legal-data-vip-title">法搜订阅会员</h2>
      <div class="legal-data-vip-card">
        <div class="legal-data-vip-card-content">
          <div class="legal-data-vip-tabs">
            <img class="legal-data-vip-tabs-bg" :src="currentTabBg" alt="" />
            <button
              v-if="!isEnterpriseRoute"
              type="button"
              class="tab-hit tab-hit--vip"
              @click="setActiveTab('VIP')"></button>
            <button
              v-if="!isEnterpriseRoute"
              type="button"
              class="tab-hit tab-hit--svip"
              @click="setActiveTab('SVIP')"></button>
          </div>
          <div class="legal-data-vip-plans" :class="{ 'is-company': activeTab === 'COMPANY' }">
            <div class="vip-plans-wrap">
              <!-- 左箭头 -->
              <button
                v-if="showPlanSwitchArrows"
                type="button"
                class="vip-plan-switch vip-plan-switch--left"
                :disabled="!canSlidePrev"
                @click="slidePlanPrev">
                <img :src="leftArrowIcon" alt="上一组套餐" width="42" height="42" />
              </button>
              <!-- 右箭头 -->
              <button
                v-if="showPlanSwitchArrows"
                type="button"
                class="vip-plan-switch vip-plan-switch--right"
                :disabled="!canSlideNext"
                @click="slidePlanNext">
                <img :src="rightArrowIcon" alt="下一组套餐" width="42" height="42" />
              </button>

              <!-- COMPANY：3列 grid，不滑动 -->
              <div v-if="isCompanyTab" class="vip-plans-container is-company">
                <div
                  v-for="plan in planList"
                  :key="plan.planId"
                  class="plan-card"
                  :class="{ 'plan-card-active': currentPlanId === plan.planId }"
                  @click="setCurrentPlanId(plan.planId)">
                  <div v-if="plan?.leftTag" class="x-data-vip-box-main-plan-leftTag">{{ plan?.leftTag }}</div>
                  <div v-if="plan?.rightTag" class="x-data-vip-box-main-plan-rightTag">{{ plan?.rightTag }}</div>
                  <div class="plan-duration">{{ plan.planName }}</div>
                  <div class="plan-price"><span class="currency">¥</span>{{ plan.planPrice / 100 }}</div>
                  <div v-if="plan.sourcePrice" class="plan-original-price">¥{{ plan.sourcePrice / 100 }}</div>
                </div>
              </div>

              <!-- VIP / SVIP：单行滑动 -->
              <div v-else ref="plansSliderRef" class="vip-plans-slider" :style="sliderCssVars">
                <div class="vip-plans-slider-track" :style="planTrackStyle">
                  <div
                    v-for="plan in planList"
                    :key="plan.planId"
                    class="plan-card"
                    :class="{ 'plan-card-active': currentPlanId === plan.planId }"
                    @click="setCurrentPlanId(plan.planId)">
                    <div v-if="plan?.leftTag" class="x-data-vip-box-main-plan-leftTag">{{ plan?.leftTag }}</div>
                    <div v-if="plan?.rightTag" class="x-data-vip-box-main-plan-rightTag">{{ plan?.rightTag }}</div>
                    <div class="plan-duration">{{ plan.planName }}</div>
                    <div class="plan-price"><span class="currency">¥</span>{{ plan.planPrice / 100 }}</div>
                    <div v-if="plan.sourcePrice" class="plan-original-price">¥{{ plan.sourcePrice / 100 }}</div>
                  </div>
                </div>
              </div>
            </div>
            <div class="vip-buy-btn">
              <a-button type="primary" @click="onBuy">立即购买</a-button>
            </div>
          </div>
        </div>
        <!--
          临时注释：会员权益区顶部标题与"新用户注册享3天试用..."入口
          如需恢复，取消注释下面这段即可
        -->
        <!-- <img class="tw-mt-[75px] tw-w-full" src="~/assets/images/legal-data/title.png" alt="" />
        <div ref="customerModalRef">
          <a-tooltip
            :align="{ points: ['tc', 'bc'], offset: [0, -8] }"
            trigger="click"
            :get-popup-container="getCustomerPopupContainer"
            overlay-class-name="customer-tips-overlay">
            <div class="">
              <img
                class="tw-mx-auto tw-mb-[42px] tw-mt-[30px] tw-block tw-h-[53px] tw-cursor-pointer"
                src="~/assets/images/legal-data/gift.png"
                alt="" />
            </div>
            <template #title>
              <div>
                <div
                  class="customer-code-pine tw-bg-[url('~/assets/images/legal-data/customer-qr-code.png')] tw-bg-cover">
                </div>
              </div>
            </template>
          </a-tooltip>
        </div> -->

        <img class="legal-data-vip-card-footer" :src="currentVipImageUrl" />
        <!-- <div class="lawyer-letter">
          <div class="lawyer-letter-title">律师函：</div>
          <div class="lawyer-letter-box">
            <div class="lawyer-letter-item">
              <div class="lawyer-letter-item-label">原价：</div>
              <div class="lawyer-letter-item-content"> <strong style="color: #fb7005">488</strong> 元/次 </div>
            </div>
            <div class="lawyer-letter-item">
              <div class="lawyer-letter-item-label">企业会员：</div>
              <div class="lawyer-letter-item-content"> <strong style="color: #fb7005">388</strong> 元/次 </div>
            </div>
            <div class="lawyer-letter-item">
              <div class="lawyer-letter-item-label">企业包年用户：</div>
              <div class="lawyer-letter-item-content"> 免费赠送 <strong style="color: #2051f3">1</strong> 次 </div>
            </div>
            <div class="lawyer-letter-item">
              <div class="lawyer-letter-item-label">企业三年用户：</div>
              <div class="lawyer-letter-item-content"> 免费赠送 <strong style="color: #2051f3">5</strong> 次 </div>
            </div>
          </div>
        </div>
        <div class="legal-data-vip-card-footer-tips">
          <div class="tips-title">合同审查次数：</div>
          <div class="legal-data-vip-card-footer-tips-box">
            <div class="vip-times"
              >包月用户每月<strong>5次</strong>，包年用户每年<strong>60次</strong>，三年用户<strong>200次</strong></div
            >
            <div class="vip-times">企业会员包年用户每年<strong>120次</strong>，三年用户<strong>400次</strong></div>
          </div>
        </div> -->
      </div>
    </div>
  </div>
</template>

<style scoped lang="less">
  .legal-data {
    --banner-title-text: 86px;
    --banner-title-leading: 101px;
    --banner-sub-title-text: 36px;
    --banner-sub-title-leading: 42px;
    --banner-btn-text: 24px;
    --banner-btn-leading: 28px;
    --banner-btn-width: 200px;
    --banner-btn-height: 72px;
    --banner-btn-download-pc: block;
    --banner-btn-download-mobile: none;
    --vip-card-rounded: 16px;
    --vip-card-border: 4px;
    --vip-tip-rounded: 12px;
    --vip-tip-text: 16px;
    --vip-tip-leading: 19px;
    --vip-time-text: 28px;
    --vip-time-leading: 33px;
    --vip-money-text: 84px;
    --vip-money-leading: 93px;
    --vip-money-prefix-text: 36px;
    --vip-money-prefix-leading: 42px;
    --vip-original-text: 22px;
    --vip-original-leading: 26px;
    --vip-btn-text: 28px;
    --vip-btn-leading: 33px;
    --vip-icon: 36px;
    --vip-icon-text: 24px;
    --vip-icon-leading: 28px;
    --vip-card-padding: 80px 166px;
    --plan-card-h: 302px;
    --vip-gap: 0 40px;
    --vip-plans-padding: 48px 64px 0 64px;
    --plan-card-height: 198px;
    --grid-template-columns: repeat(4, 1fr);
    --flex-direction: row;
    --contact-item-width: 320px;
    --flex-gap: 16px;
    --org-benefits-title-width: 405px;
    --org-benefits-title-aspect: 405/32;
    --rights-title-font-size: 36px;
    --rights-title-box-line-width: 35%;
    --limited-offer-tag-padding: 5px 19px;
    --plan-card-margin-bottom: 8px;

    min-width: 320px;
    overflow-x: auto;

    @media (max-width: 1536px) {
      --vip-card-padding: 60px 77px;
    }

    @media (max-width: 1280px) {
      --vip-card-padding: 50px 38px;
      --rights-title-font-size: 36px;
      --rights-title-box-line-width: 30%;
    }

    @media (max-width: 1024px) {
      --banner-title-text: 66px;
      --banner-title-leading: 79px;
      --vip-card-padding: 40px 26px;
      --vip-gap: 0 20px;
      --contact-item-width: 320px;
      --rights-title-font-size: 30px;
      --rights-title-box-line-width: 28%;
      --limited-offer-tag-padding: 3px 12px;
    }

    @media (max-width: 768px) {
      --banner-title-text: 56px;
      --banner-title-leading: 66px;
      --banner-btn-text: 16px;
      --banner-btn-leading: 20px;
      --banner-btn-width: 126px;
      --banner-btn-height: 42px;
      --banner-btn-download-pc: none;
      --banner-btn-download-mobile: block;
      --vip-tip-text: 12px;
      --vip-tip-leading: 16px;
      --vip-card-rounded: 8px;
      --vip-tip-rounded: 6px;
      --vip-card-border: 2px;
      --vip-time-text: 20px;
      --vip-time-leading: 23px;
      --vip-money-text: 48px;
      --vip-money-leading: 48px;
      --vip-money-prefix-text: 24px;
      --vip-money-prefix-leading: 24px;
      --vip-original-text: 16px;
      --vip-original-leading: 19px;
      --vip-btn-text: 20px;
      --vip-btn-leading: 23px;
      --vip-icon: 22px;
      --vip-icon-text: 18px;
      --vip-icon-leading: 21px;
      --plan-card-h: 224px;
      --vip-gap: 0 8px;
      --vip-card-padding: 30px 20px;
      --vip-plans-padding: 38px 54px 0 54px;
      --grid-template-columns: repeat(2, 1fr);
      --contact-item-width: 290px;
      --rights-title-font-size: 24px;
      --rights-title-box-line-width: 29%;
    }

    @media (max-width: 640px) {
      --banner-title-text: 38px;
      --banner-title-leading: 46px;
      --vip-card-padding: 20px 20px;
      --plan-card-height: 174px;
      --vip-plans-padding: 30px 44px 0 44px;
      --contact-item-width: 320px;
      --flex-direction: column;
      --flex-gap: 0;
      --org-benefits-title-width: 385px;
      --org-benefits-title-aspect: 385/32;
      --rights-title-font-size: 20px;
      --rights-title-box-line-width: 25%;
      --limited-offer-tag-padding: 2.6px 10px;
    }

    @media (max-width: 480px) {
      --banner-sub-title-text: 26px;
      --banner-sub-title-leading: 32px;
      --banner-title-text: 28px;
      --banner-title-leading: 36px;
      --vip-time-text: 12px;
      --vip-time-leading: 16px;
      --vip-money-text: 24px;
      --vip-money-leading: 24px;
      --vip-money-prefix-text: 12px;
      --vip-money-prefix-leading: 16px;
      --vip-original-text: 12px;
      --vip-original-leading: 12px;
      --vip-btn-text: 20px;
      --vip-btn-leading: 23px;
      --vip-icon: 22px;
      --vip-icon-text: 14px;
      --vip-icon-leading: 16px;
      --plan-card-h: 160px;
      --vip-card-padding: 10px 20px;
      --plan-card-height: 154px;
      --vip-plans-padding: 24px 34px 0 34px;
      --grid-template-columns: repeat(1, 1fr);
      --contact-item-width: 320px;
      --org-benefits-title-width: 305px;
      --org-benefits-title-aspect: 305/32;
      --rights-title-font-size: 18px;
      --rights-title-box-line-width: 19%;
      --limited-offer-tag-padding: 5px 19px;
      --plan-card-margin-bottom: 0;
    }

    @media (max-width: 400px) {
      --contact-item-width: 280px;
      --org-benefits-title-width: 290px;
      --org-benefits-title-aspect: 290/32;
      --rights-title-box-line-width: 19%;
    }

    @media (max-width: 360px) {
      --contact-item-width: 260px;
      --org-benefits-title-width: 265px;
      --org-benefits-title-aspect: 265/32;
      --rights-title-box-line-width: 15%;
      --limited-offer-tag-padding: 2.6px 10px;
    }

    .legal-data-banner {
      height: 945px;
      overflow: hidden;
      background-position: center;
      background-size: cover;

      .legal-data-banner-content {
        width: min-content();
        min-width: 100%;
        margin: 172px auto 0;

        p {
          padding: 0 32px;
          margin-bottom: 0;
          font-size: var(--banner-title-text);
          font-weight: bolder;
          line-height: var(--banner-title-leading);
          color: #fff;
          text-align: center;

          &:nth-of-type(1) {
            margin-bottom: 24px;
            font-size: var(--banner-sub-title-text);
            line-height: var(--banner-sub-title-leading);
          }
        }

        .legal-data-btns {
          position: relative;
          display: flex;
          gap: 28px;
          align-items: center;
          justify-content: center;
          width: min-content;
          margin: 167px auto 0;

          .ant-btn {
            display: flex;
            align-items: center;
            justify-content: center;
            width: var(--banner-btn-width);
            height: var(--banner-btn-height);
            font-size: var(--banner-btn-text);
            font-weight: 600;
            line-height: var(--banner-btn-leading);
            color: #fff;
            background: linear-gradient(90deg, #3858ff 0%, #66f 100%);
            border: none !important;
            border-radius: 4px;
          }

          .app-download-btn {
            color: #0a5cff;
            background-color: white;
            background-image: none;
          }

          .app-download-mobile {
            display: var(--banner-btn-download-mobile);
          }

          .app-download-pc {
            display: var(--banner-btn-download-pc);
          }
        }
      }
    }

    .legal-data-icons {
      display: flex;
      flex-wrap: wrap;
      gap: 16px 64px;
      align-items: center;
      justify-content: center;
      min-height: 90px;
      padding: 28px 0;
      font-size: 24px;
      line-height: 28px;
      color: #fff;
      background: linear-gradient(90deg, #7484ed 0%, #61b8ff 45%, #7371f9 100%);

      .legal-data-icon {
        display: flex;
        align-items: center;
        justify-content: center;

        .anticon {
          margin-right: 8px;
          font-size: 24px;
        }

        &:last-of-type {
          &::after {
            margin-left: 17px;
            content: "...";
          }
        }
      }
    }

    .legal-data-show {
      display: flex;
      align-items: center;
      justify-content: center;
      max-height: 1080px;
      padding: 90px 0;
      background-position: center center;
      background-size: cover;

      .legal-data-show-image {
        width: 80.89%;
        height: auto;
        aspect-ratio: 1553 / 900;
        object-fit: cover;
      }
    }

    .legal-data-advantage {
      min-height: 933px;
      padding: 0 16px;
      overflow: hidden;
      background: rgba(206, 218, 255, 54%);

      .legal-data-advantage-title {
        position: relative;
        margin-top: 96px;
        margin-bottom: 72px;
        font-size: 40px;
        font-weight: bold;
        line-height: 47px;
        color: #333;
        text-align: center;

        &::after {
          position: absolute;
          bottom: -13px;
          left: 50%;
          display: block;
          width: 32px;
          height: 6px;
          content: "";
          background: linear-gradient(90deg, #0a5cff 0%, #66f 100%);
          transform: translateX(-50%);
        }
      }

      .legal-data-enterprise-box {
        display: flex;
        flex-wrap: wrap;
        gap: 24px;
        justify-content: center;
        margin: 0 auto;

        .legal-data-enterprise-card {
          display: flex;
          flex-direction: column;
          align-items: center;
          width: 314px;
          height: 492px;
          padding: 0 37px;
          background: #fff;
          border-style: solid;
          border-width: 6px 0 0;
          border-radius: 8px;
          border-image: linear-gradient(90deg, rgba(10, 92, 255, 100%), rgba(102, 102, 255, 100%)) 6 6;
          box-shadow: 0 8px 32px 0 rgba(168, 179, 255, 20%);

          .anticon {
            margin-top: 96px;
            font-size: 72px;
          }

          .legal-data-enterprise-card-title {
            margin-top: 48px;
            margin-bottom: 24px;
            font-size: 24px;
            font-weight: 600;
          }

          .legal-data-enterprise-card-text {
            font-size: 18px;
            color: #5a5d66;
          }
        }
      }

      .legal-data-advantage-box {
        display: flex;
        flex-wrap: wrap;
        gap: 20px;
        justify-content: center;
        max-width: 1736px;
        margin: 0 auto;

        .legal-data-advantage-card {
          display: grid;
          grid-template-columns: repeat(2, 1fr);
          width: 514px;
          height: 862px;
          padding: 56px 0;
          background: #fff;
          border-radius: 8px;

          &:last-of-type {
            grid-template-columns: auto;

            h3 {
              grid-column: span 1;
            }
          }

          h3 {
            grid-column: span 2;
            justify-self: center;
            margin-bottom: 0;
            font-size: 40px;
            font-weight: 600;
            line-height: 47px;
            color: #333;
          }

          .legal-data-advantage-card-icon {
            display: flex;
            flex-direction: column;
            align-items: center;

            .anticon {
              margin-bottom: 24px;
              font-size: 72px;
            }

            span {
              font-size: 20px;
              font-weight: 400;
              line-height: 23px;
              color: #5a5d66;
            }
          }
        }
      }
    }

    .legal-data-vip {
      min-height: 1080px;
      padding: 0 16px 206px;
      overflow: hidden;
      background: rgba(206, 218, 255, 54%);

      .legal-data-vip-title {
        position: relative;
        margin-top: 96px;
        margin-bottom: 72px;
        font-size: 40px;
        font-weight: bold;
        line-height: 47px;
        color: #333;
        text-align: center;

        &::after {
          position: absolute;
          bottom: -13px;
          left: 50%;
          display: block;
          width: 32px;
          height: 6px;
          content: "";
          background: linear-gradient(90deg, #0a5cff 0%, #66f 100%);
          transform: translateX(-50%);
        }
      }

      .legal-data-vip-card {
        width: 100%;
        max-width: 1736px;
        padding: var(--vip-card-padding);
        margin: 0 auto;
        background: #fff;
        border-radius: 16px;

        .legal-data-vip-card-content {
          width: 100%;
          height: fit-content;

          .legal-data-vip-tabs {
            position: relative;
            width: 100%;
          }

          .legal-data-vip-tabs-bg {
            display: block;
            width: 100%;
            height: auto;
            pointer-events: none;
            user-select: none;
            -webkit-user-drag: none;
          }

          .legal-data-vip-tabs .tab-hit {
            position: absolute;
            top: 0;
            bottom: 0;
            width: 50%;
            cursor: pointer;
            background: transparent;
            border: none;
          }

          .legal-data-vip-tabs .tab-hit--vip {
            left: 0;
          }

          .legal-data-vip-tabs .tab-hit--svip {
            right: 0;
          }

          .vip-buy-btn {
            display: flex;
            align-items: center;
            justify-content: center;
            padding: 60px 0;

            .ant-btn {
              width: 480px;
              height: 58px;
              font-size: 20px;
              font-weight: 500;
              cursor: pointer;
              background: #0a6cff;
              border-radius: 30px;

              &:hover {
                cursor: pointer;
                opacity: 0.9;
              }
            }
          }

          .legal-data-vip-plans {
            width: 100%;
            padding: var(--vip-plans-padding);
            background-color: #fff8f0;

            .vip-plans-wrap {
              position: relative;
              width: 100%;
            }

            // 箭头按钮
            .vip-plan-switch {
              position: absolute;
              top: 50%;
              z-index: 2;
              width: 42px;
              height: 42px;
              padding: 0;
              cursor: pointer;
              background: transparent;
              border: 0;
              transform: translateY(-50%);

              img {
                display: block;
                width: 42px;
                height: 42px;
              }

              &:disabled {
                cursor: not-allowed;
                opacity: 0.35;
              }
            }

            .vip-plan-switch--left {
              left: -22px;
            }

            .vip-plan-switch--right {
              right: -22px;
            }

            // COMPANY 3列 grid
            .vip-plans-container.is-company {
              display: grid;
              grid-template-columns: repeat(3, minmax(0, 1fr));
              gap: 25px;
              width: 100%;
            }

            // VIP/SVIP 滑动容器
            .vip-plans-slider {
              width: 100%;
              overflow: hidden;
            }

            .vip-plans-slider-track {
              display: flex;
              gap: 12px;
              width: fit-content;
              will-change: transform;

              .plan-card {
                flex: 0 0 var(--plan-card-width);
                width: var(--plan-card-width);
              }
            }

            // 套餐卡片公共样式
            .plan-card {
              position: relative;
              display: flex;
              flex-direction: column;
              align-items: center;
              justify-content: center;
              height: var(--plan-card-height);
              text-align: center;
              cursor: pointer;
              background-color: #fff;
              border: 2px solid #ffe1d0;
              border-radius: 24px;

              .x-data-vip-box-main-plan-leftTag {
                position: absolute;
                top: 0;
                left: 0;
                padding: 4px 11px;
                font-size: 12px;
                color: #9b4f2e;
                background: #ffe1d0;
                border-radius: 23px 0;
              }

              .x-data-vip-box-main-plan-rightTag {
                position: absolute;
                top: -8px;
                right: -4px;
                display: flex;
                align-items: center;
                justify-content: center;
                width: 34px;
                height: 34px;
                font-size: 8px;
                font-weight: 500;
                color: #9b4f2e;
                text-align: center;
                white-space: normal;
                background: url("~/assets/images/legal-data/right-tag.png");
                background-size: cover;
              }

              .plan-duration {
                margin-bottom: var(--plan-card-margin-bottom);
                font-size: 20px;
                color: #683510;
              }

              .plan-price {
                margin-bottom: var(--plan-card-margin-bottom);
                font-size: 48px;
                font-weight: 500;
                color: #9b4f2e;

                .currency {
                  font-size: 32px;
                }
              }

              &.plan-card-active {
                background: linear-gradient(135deg, #fff6e9 0%, #fed9be 100%);
                border-color: #e79466;

                .x-data-vip-box-main-plan-rightTag {
                  color: #fff;
                  background: url("~/assets/images/legal-data/right-active-tag.png");
                  background-size: cover;
                }

                .x-data-vip-box-main-plan-leftTag {
                  color: #fff;
                  background: #ed6425;
                }

                .plan-price {
                  color: #f54a01;
                }
              }

              .plan-original-price {
                font-size: 20px;
                color: #ce9676;
                text-decoration: line-through;
              }
            }
          }

          .company-vip-card {
            width: 100%;
            min-height: 294px;
            padding: 48px 64px;
            background-color: #fff8f0;

            .company-vip-box {
              display: flex;
              flex-wrap: wrap;
              gap: 25px;
              align-items: center;
              justify-content: center;

              .company-vip-item {
                position: relative;
                box-sizing: content-box;
                display: flex;
                flex: 1;
                flex-direction: column;
                justify-content: center;
                width: 0;
                min-width: 400px;
                height: auto;
                aspect-ratio: 625/198;
                cursor: pointer;
                background: #fff;
                border: 2px solid #ffe1d0;
                border-radius: 24px;

                .x-data-vip-box-main-plan-leftTag {
                  position: absolute;
                  top: 0;
                  left: 0;
                  padding: 4px 11px;
                  font-size: 12px;
                  color: #9b4f2e;
                  background: #ffe1d0;
                  border-radius: 23px 0;
                }

                .x-data-vip-box-main-plan-rightTag {
                  position: absolute;
                  top: -8px;
                  right: -4px;
                  display: flex;
                  align-items: center;
                  justify-content: center;
                  width: 34px;
                  height: 34px;
                  font-size: 8px;
                  font-weight: 500;
                  color: #9b4f2e;
                  text-align: center;
                  white-space: normal;
                  background: url("~/assets/images/legal-data/right-tag.png");
                  background-size: cover;
                }

                &.company-vip-recommend {
                  background-image: url("~/assets/images/legal-data/recommend-bg.svg");
                  background-repeat: no-repeat;
                  background-size: 100% 100%;

                  .company-vip-item-icon {
                    top: -18px;
                    font-size: 68px;
                  }

                  .company-vip-box {
                    .company-vip-left {
                      .company-vip-left-price {
                        .company-vip-left-price-plan {
                          color: #ed6425;
                        }
                      }
                    }
                  }
                }

                &.company-vip-item-selected {
                  border: 1px solid #ce854a;

                  .x-data-vip-box-main-plan-rightTag {
                    color: #fff;
                    background: url("~/assets/images/legal-data/right-active-tag.png");
                    background-size: cover;
                  }

                  .x-data-vip-box-main-plan-leftTag {
                    color: #fff;
                    background: #ed6425;
                  }
                }

                .company-vip-item-icon {
                  position: absolute;
                  top: -36px;
                  left: 0;
                  font-size: 104px;
                }

                .company-vip-box {
                  display: flex;
                  align-items: center;
                  justify-content: space-between;
                  padding: 0 56px;

                  .company-vip-right {
                    font-size: 24px;
                    font-weight: bold;
                    color: #18173e;
                  }

                  .company-vip-left {
                    display: flex;
                    flex-direction: column;
                    align-items: flex-end;
                    justify-content: center;

                    .company-vip-left-price {
                      display: flex;
                      flex-direction: column;
                      align-items: flex-end;

                      .company-vip-left-price-plan {
                        font-size: 48px;
                        color: #683510;

                        &::before {
                          font-size: 32px;
                          content: "¥";
                        }
                      }

                      .company-vip-left-price-source {
                        font-size: 20px;
                        color: #b1682c;
                        text-decoration: line-through;

                        &::before {
                          text-decoration: none;
                          content: "原价：";
                        }

                        &::after {
                          text-decoration: none;
                          content: "/年";
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }

        .legal-data-vip-card-footer {
          width: 100%;
          height: auto;
          padding-top: 48px;

          // .vip-card-member-rights {
          //   width: 100%; // 5列 * 280px
          //   margin-right: auto;
          //   margin-left: auto;

          //   .rights-title-box {
          //     display: flex;
          //     align-items: center;
          //     justify-content: center;
          //     margin-bottom: 72px;

          //     .rights-title {
          //       margin: 0 24px;
          //       font-size: var(--rights-title-font-size);
          //       font-weight: 500;
          //       line-height: 42px;
          //       color: transparent;
          //       text-align: center;
          //       background: linear-gradient(0deg, #ed9c1f 0%, #ea7a36 100%);
          //       background-clip: text;
          //     }

          //     .rights-title-box-line-left {
          //       width: var(--rights-title-box-line-width);
          //       height: 1px;
          //       background: linear-gradient(90deg, rgba(255, 195, 79, 0%) 0%, #ffc34f 100%);
          //       border-radius: 2px;
          //     }

          //     .rights-title-box-line-right {
          //       width: var(--rights-title-box-line-width);
          //       height: 1px;
          //       background: linear-gradient(90deg, #eb9762 0%, rgba(235, 151, 98, 0%) 100%);
          //       border-radius: 2px;
          //     }
          //   }

          //   .rights-table-box {
          //     width: 100%;
          //     height: auto;
          //   }
          // }
        }

        .lawyer-letter {
          .lawyer-letter-title {
            margin-top: 24px;
            margin-bottom: 12px;
            margin-left: 81px;
            font-size: 16px;
            color: #8b8b93;
          }

          .lawyer-letter-box {
            display: flex;
            flex-wrap: wrap;
            align-items: center;
            justify-content: space-between;
            width: 100%;
            height: 54px;
            padding: 0 81px;
            background: #fefefd;
            border: 1px solid #f1f1f1;
            border-radius: 10px;

            .lawyer-letter-item {
              display: flex;
              gap: 4px;
              align-items: center;
              justify-content: center;

              .lawyer-letter-item-label {
                font-size: 16px;
                color: #af997a;
              }

              .lawyer-letter-item-content {
                font-size: 16px;
                color: #3c3b5d;
              }
            }
          }
        }

        .legal-data-vip-card-footer-tips {
          margin-top: 16px;
          margin-left: 74px;

          .tips-title {
            margin-bottom: 12px;
            font-size: 16px;
            color: #8b8b93;
          }

          .legal-data-vip-card-footer-tips-box {
            display: flex;
            flex-wrap: wrap;
            gap: 24px;

            .vip-times {
              font-size: 16px;
              color: #3c3b5d;

              strong {
                color: #fbbc05;
              }
            }
          }
        }
      }
    }
  }

  :deep(.customer-tips-overlay) {
    // width: 198px;
    width: 528px;
    height: 268px;
    border-radius: 24px;

    &.ant-tooltip {
      max-width: 35rem !important;
      padding: 0;
    }

    .ant-tooltip-inner {
      padding: 0 !important;
      background: none !important;
      box-shadow: none !important;
    }

    .ant-tooltip-arrow {
      display: none;

      &::before {
        background: #fff;
      }
    }

    .customer-code-pine {
      width: 528px;
      height: 268px;

      .qr-code {
        width: 106px;
        height: 106px;
      }

      .tip {
        font-size: 14px;
        color: #969696;
      }
    }
  }
</style>
<style lang="less">
  // APP/小程序二维码 tooltip
  .qrcode-tooltip {
    .ant-tooltip-inner {
      padding: 8px;
      background: #fff;
      border-radius: 8px;
      box-shadow: 0 4px 16px rgba(0, 0, 0, 15%);
    }

    .qrcode-tooltip-img {
      display: block;
      width: 148px;
      height: 148px;
      object-fit: contain;
    }
  }

  // 适配购买弹窗
  .legal-data-buy-modal {
    .x-purchase-plan-modal {
      .ant-modal {
        width: auto !important;
        min-width: 288px;
        max-width: 1323px;

        .x-purchase-plan {
          flex-wrap: wrap;
          gap: 8px;
          justify-content: center;

          .setmeal {
            width: 100vw;
            min-width: 288px;
            max-width: 928px;
            height: auto;
            min-height: 722px;
            margin-right: 0;

            .header {
              .desc {
                .desc-row {
                  flex-wrap: wrap;
                }
              }
            }

            .items {
              .items-plan {
                flex-wrap: wrap;
                gap: 32px;
                justify-content: center;

                .plan-item {
                  max-width: 230px;
                  margin-right: 0;
                }
              }
            }
          }
        }
      }
    }
  }
</style>
